import React, { useEffect, useState } from "react";
import RedError from "../../../assets/Images/round_error.svg";
import BlueError from "../../../assets/Images/round_error_blue.svg";
import Greentick from "../../../assets/Images/check_circle_greentick.svg";

const ReportsOverview = (props) => {

  const {reconciliationReport} = props;

  const [matchedReport, setMatchedReport] = useState([]);
  const [notinplanReport, setNotinplanReport] = useState([]);
  const [additionalReport, setAdditionalReport] = useState([]);

  useEffect(() => {
    const matchedreport = [];
    const notinplanreport = [];
    const additionalreport = [];
    reconciliationReport?.information && reconciliationReport.information.forEach((item) => {
      if (item?.matched) {
        matchedreport.push(item);
      } else if (item?.not_in_plan) {
        notinplanreport.push(item);
      } else if (item?.additional) {
        additionalreport.push(item);
      }
    });
    setMatchedReport(matchedreport);
    setNotinplanReport(notinplanreport);
    setAdditionalReport(additionalreport);
  },[])

  return (
    <>
      <div className="reconciliation-sidebar-section-summary">
        <div className="reconsidebar-section-summary-overview">

          <div className="flex-box">
            <div>
              <img alt="Matched" src={Greentick} />
            </div>
            <div className="reconsidebar-section-summary-padding">
              <div>
                <span className="summary-overview-heading ">
                  <span className="summary-overview-matched">{matchedReport.length} Matched</span>
                  <span>{" "} - Available in index and plan document</span>
                </span>
              </div>
            </div>
          </div>

          <div className="flex-box summary-overview-margins">
            <div>
              <img alt="Notinplan" src={RedError} />
            </div>
            <div className="reconsidebar-section-summary-padding">
              <div>
                <span className="summary-overview-heading ">
                  <span className="summary-overview-notinplan">{notinplanReport.length} Not in plan</span>
                  <span>{" "} - Available in index but missing in plan document</span>
                </span>
              </div>
              {/* {notinplanReport.length > 0 ? (
                <div>
                  {notinplanReport.map((item,index) => {
                    return (
                      <div key={index + 1}>{index + 1}.{item.sheet_name}</div>
                    )
                  })
                  }
                </div>
                ) : null
              } */}
            </div>
          </div>

          <div className="flex-box summary-overview-margins">
            <div>
              <img alt="Additional" src={BlueError} />
            </div>
            <div className="reconsidebar-section-summary-padding">
              <div>
                <span className="summary-overview-heading ">
                  <span className="summary-overview-additional">{additionalReport.length} Additional</span>
                  <span>{" "} - Missing in index but available in plan document</span>
                </span>
              </div>
              {/* {additionalReport.length > 0 ? (
                <div>
                  {additionalReport.map((item,index) => {
                    return (
                      <div key={index + 1}>{index + 1}.{item.sheet_name}</div>
                    )
                  })
                  }
                </div>
                ) : null
              } */}
            </div>
          </div>
          
        </div>
      </div>
    </>
  );
}

export default ReportsOverview;